<app-bannerusuario></app-bannerusuario>
 

<div class="contenedorMain">
  <div class="contenedorChild">

    <div class="contenedorChildTwo">

      <div class="col1">
        <h2 class="titleInterno ">

          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M23.3335 11.6667C23.3335 9.82833 21.8385 8.33333 20.0002 8.33333C18.1618 8.33333 16.6668 9.82833 16.6668 11.6667C16.6668 13.505 18.1618 15 20.0002 15C21.8385 15 23.3335 13.505 23.3335 11.6667ZM26.6668 11.6667C26.6668 15.3433 23.6768 18.3333 20.0002 18.3333C16.3235 18.3333 13.3335 15.3433 13.3335 11.6667C13.3335 7.99 16.3235 5 20.0002 5C23.6768 5 26.6668 7.99 26.6668 11.6667ZM8.3335 33.3333C8.3335 26.9 13.5685 21.6667 20.0002 21.6667C26.4318 21.6667 31.6668 26.9 31.6668 33.3333C31.6668 34.2533 30.9218 35 30.0002 35C29.0785 35 28.3335 34.2533 28.3335 33.3333C28.3335 28.7383 24.5952 25 20.0002 25C15.4052 25 11.6668 28.7383 11.6668 33.3333C11.6668 34.2533 10.9218 35 10.0002 35C9.0785 35 8.3335 34.2533 8.3335 33.3333Z"
              fill="#DA291C" />
          </svg>

          Usuarios
        </h2>

      </div>
      <div class="col2">
        <input type="text" class="inputCombo comboUsuarios" placeholder="Ingresar valor a filtrar" [(ngModel)]="filtro"
          (keyup.enter)="Lista_Usuarios()" style="text-align: center;">

          <button class="button registrar" style="width: 228px; height: 36px; margin-left: 15px;" data-bs-toggle="modal" data-bs-target="#exampleModal">
            Registrar Usuario
          </button>


      </div>
      <div class="col3">
        <p><b>Se han registrado {{cantidad_registros}} usuarios</b></p>
      </div>
    </div>

    <div>
      <div class="tableMain">


        <table class="table">
          <thead>
            <tr class="table-secondary" style="border-radius: 50">
              <th scope="col" style="text-align: center;">id</th>
              <th scope="col" style="text-align: center;">Nombres</th>
              <th scope="col" style="text-align: center;">Apellidos</th>
              <th scope="col" style="text-align: center;">Email</th>
              <th scope="col" style="text-align: center;">Rol</th>
              <th scope="col" style="text-align: center;">Estado</th>
              <th scope="col" style="text-align: center;">Historial</th>

              <!--   <th scope="col"></th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let result of Usuario_List">
              <th scope="row">{{result.id}}</th>
              <td style="text-align: center;">{{result.nombres}}</td>
              <td style="text-align: center;">{{result.apellidos}}</td>
              <td style="text-align: center;">{{result.email}}</td>
              <td style="text-align: center;">{{result.rol}}</td>
              <td style="text-align: center;">
                <input class="switchInput" type="checkbox" id="switch-{{result.id}}"
                (click)="desactivarCuenta(result.id, result.estado_bool)" [(ngModel)]="result.estado_bool" />
                <label class="switchLabel" for="switch-{{result.id}}">Toggle</label>

              </td>
              <td style="text-align: center;">
                <button type="button" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#exampleModalHistorial"
                  (click)="verHistorialUsuario(result)" title="Ver historial de {{result.nombres}}">
                  <i class="bi bi-clock-history"></i>
                </button>
              </td>
              <!--    
                  <td style="text-align: left;">
                     <i class="bi bi-circle-fill" [ngClass]="{'small-icon': true}"
                    [ngStyle]="{color: result.estado === 'activo' ? 'green' : 'red'}" style="padding-right: 10px;">
                  </i>{{result.estado}}
                  </td>

                          <td>
                    
                    <button type="button" class="btn btn-warning" data-bs-toggle="modal" data-bs-target="#exampleModal"
                      (click)="cargaPoputDetalle(result)">
                      <i class="bi bi-person-fill"></i>
                    </button>

                  </td>-->

            </tr>
          </tbody>
        </table>
      </div>

      <!--
            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
              aria-hidden="true">
              <div class="modal-dialog modal-xl">
                <div class="modal-content">
                  <div class="modal-header">

                    <h5 class="modal-title" id="exampleModalLabel">Usuario: {{nombres +' ' + apellidos}} </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <div class="container-fluid">

                      <div class="row">
                        <div class="col-md-1">Codigo:</div>
                        <div class="col-md-3"><input type="text" class="form-control" disabled [(ngModel)]="codigo">
                        </div>
                      </div>
                      <br>
                      <div class="row">
                        <div class="col-md-1">Nombres:</div>
                        <div class="col-md-5"><input type="text" class="form-control" disabled [(ngModel)]="nombres">
                        </div>
                        <div class="col-md-1">Apellidos:</div>
                        <div class="col-md-5"><input type="text" class="form-control" disabled [(ngModel)]="apellidos">
                        </div>
                      </div>
                      <br>
                      <div class="row">
                        <div class="col-md-1">Rol:</div>
                        <div class="col-md-5"><input type="text" class="form-control" disabled [(ngModel)]="rol">
                        </div>
                        <div class="col-md-1">Correo:</div>
                        <div class="col-md-5"><input type="text" class="form-control" disabled [(ngModel)]="correo">
                        </div>
                      </div>
                      <br>
                      <div class="row">

                        <div class="col-md-1">Activo:</div>
                        <div class="col-md-1">
                          <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"
                              [(ngModel)]="estado_bit">

                          </div>
                        </div>
                      </div>
                      <br>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                        (click)="desactivarCuenta()">Guardar</button>
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
         
            <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel2"
              aria-hidden="true">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">

                    <h5>¿Está seguro de desactivar el usuario {{nombres +' ' + apellidos}}?</h5>
                    <p>Esta acción es totalmente irreversible y no se podrá recuperar.</p>
                  </div>
                  <div style="text-align: center;">
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                      (click)="desactivarCuenta()">{{activo_desactivo}}</button>
                  </div>
                  <br>

                </div>
              </div>
            </div>
 -->

      
<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel2" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modalUsuario">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body modalUsuarios">
        <h5 class="titleModal">Nuevo Usuario</h5>
        <div class="box1">
          <p class="label">Nombres:</p>
          <input type="text" class="form-control" [(ngModel)]="nombres">
        </div>
        <div class="box2">
          <p class="label">Apellidos:</p>
          <input type="text" class="form-control" [(ngModel)]="apellidos">
        </div>
        <div class="box1">
          <p class="label">Email:</p>
          <input type="text" class="form-control" [(ngModel)]="correo">
        </div>
        <div class="box2">
          <p class="label">Rol:</p>
          <select class="seleccionarCombo" [(ngModel)]="rol">
            <option value="">Seleccionar</option>
            <option value="Usuario">Usuario</option>
            <option value="Administrador">Administrador</option>
          </select>
        </div>
        <div class="box1">
          <p class="label">Password:</p>
          <input type="password" class="form-control" [(ngModel)]="contrasena">
        </div>
      </div>
      <div style="text-align: center;">
        <button class="btn btn-danger registrar" (click)="registrarUsuario()">Registrar Usuario</button>
      </div>
      <br>
    </div>
  </div>
</div>

<!-- Modal: Historial de Acciones -->
<div class="modal fade" id="exampleModalHistorial" tabindex="-1" aria-labelledby="exampleModalHistorialLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content modalHistorial">
      <div class="modal-header">
        <h5 class="titleModal" id="exampleModalHistorialLabel">
          <i class="bi bi-clock-history"></i>
          Historial de {{usuarioHistorialSeleccionado?.nombres}} {{usuarioHistorialSeleccionado?.apellidos}}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="tableMain">
          <table class="table tablaHistorial">
            <thead>
              <tr class="table-secondary">
                <th scope="col">Acción</th>
                <th scope="col" style="text-align: left;">URL / Código</th>
                <th scope="col">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Historial_Filtrado">
                <td>
                  <span class="badgeAccion" [ngClass]="'badge-' + (item.accion ?? '').toLowerCase()">{{item.accion}}</span>
                </td>
                <td style="text-align: left;">{{item.url_qr}}</td>
                <td>{{item.fecha_accion | date:'dd/MM/yyyy HH:mm'}}</td>
              </tr>
              <tr *ngIf="Historial_Filtrado.length === 0">
                <td colspan="3">Este usuario todavía no tiene acciones registradas.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
    </div>
  </div>
</div>

<app-footer></app-footer>

<app-loading *ngIf="loading$ | async"></app-loading>